import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { clsx } from 'clsx';

import { getCurrencySymbol, trimZeroCents } from '../lib';

import styles from './stats.module.css';

export function StatCard({ card, value, currency }) {
	const intl = useIntl();
	const navigate = useNavigate();

	const { amount = 0, change, trend = 'up', monthName } = value ?? {};
	const isGoal = card.id === 'goal';
	const TrendIcon = trend === 'down' ? TrendingDown : TrendingUp;

	return (
		<div
			className={clsx(styles.card, styles[card.id])}
			onClick={() => navigate(card.path)}
		>
			<div className={styles.title}>
				{intl.formatMessage({ id: card.titleId })}
			</div>
			<div className={styles.valueRow}>
				<span className={styles.amount}>
					{trimZeroCents(amount)}
					{getCurrencySymbol(value?.currency ?? currency)}
				</span>
				{!isGoal && <span className={styles.month}>{monthName}</span>}
			</div>
			<div className={styles.bottomRow}>
				<span className={styles.change}>
					{change ?? intl.formatMessage({ id: card.emptyChangeId })}
				</span>
				{!isGoal && <TrendIcon size={18} className={styles.trend} />}
			</div>
		</div>
	);
}
